import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TRemovePaymentQrCode = IAction<EPaymentActions.REMOVE_PAYMENT_QR_CODE, null>

const removePaymentQrCode = (): TRemovePaymentQrCode => ({
    type: EPaymentActions.REMOVE_PAYMENT_QR_CODE,
    payload: null,
});

export default removePaymentQrCode;
